export const HIDE_ABOUT_MODAL = "HIDE_ABOUT_MODAL";
export const hideAboutModal = () => ({ type: HIDE_ABOUT_MODAL });

export const SHOW_ABOUT_MODAL = "SHOW_ABOUT_MODAL";
export const showAboutModal = () => ({ type: SHOW_ABOUT_MODAL });
